import React from "react";
import PropTypes from "prop-types";
import { buttonName, InvoiceDetails } from "../../locales/en";
import CommonModal from "./CommonModal";

const VoidedInvoiceInfoModal = ({ isOpen, toggle }) => (
  <CommonModal
    isOpen={isOpen}
    toggle={toggle}
    title={InvoiceDetails?.voidedModalaData?.title}
    footerButtons={[
      {
        label: buttonName.close,
        className: "btn btn-secondary",
        onClick: () => toggle(false)
      }
    ]}
  >
    <p>{InvoiceDetails?.voidedModalaData?.subTitle}</p>
  </CommonModal>
);

VoidedInvoiceInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default VoidedInvoiceInfoModal;
